import React from 'react';
import { Modal } from 'react-bootstrap';
import RMButton from 'components/customComponents/Controls/RMButton';
type PreparedStocksWarningModalProps = {
  show: boolean;
  setShow: (boolean) => void;
  stocksList: string[];
};
export const PreparedStocksWarningModal = ({
  show,
  setShow,
  stocksList,
}: PreparedStocksWarningModalProps) => {
  return (
    <Modal id="preparedstockswarning-modal" show={show}>
      <Modal.Body id="preparedstockswarning-modal-body"
        style={{ display: 'flex', flexDirection: 'column' }}>
        <div id="preparedstockswarning-modal-title"
          style={{
            marginBottom: '1rem',
            color: '#F89723',
            fontWeight: 700,
            fontSize: '1rem',
            fontFamily: 'Arial',
          }}
        >
          Prepared Stock Subtitution Prompt
        </div>
        <p id="preparedstockswarning-modal-desc">Prepared stocks was not found for the following Ingredients.</p>
        <div id="preparedstockswarning-modal-stocklist" style={{ overflowY: 'auto' }}>
          {stocksList.map((s, index) => {
            return (
              <p id={`preparedstockswarning-modal-stockitem-${index}`} key={`stocks${index}`} style={{ fontWeight: 'bold' }}>
                {s}
              </p>
            );
          })}
        </div>
        <br />
        <div  id="preparedstockswarning-modal-buttonwrapper" style={{ display: 'flex', alignSelf: 'center' }}>
          <RMButton 
            id="preparedstockswarning-modal-button-ok"
            onClick={() => {
              setShow(false);
            }}
            customStyle={{ backgroundColor: '#F7A246', width: '8rem' }}
            label="Ok"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
